export interface Heading {
  node: Element;
  key: string;
  text: string;
  level: number;
  scrollIntoView: () => any;
  isIntersecting: boolean;
}

export type Catalog = Heading[];

export interface CatalogData {
  catalog: Catalog;
  minLevel: number;
}

export const emptyCatalogData: CatalogData = {
  catalog: [],
  minLevel: 7,
};

export type CatalogStyle = "none" | "number" | "circle" | "rect" | "point";

class MessageService<T = any> {
  private fs: Array<(arg: T) => any> = [];

  constructor(private val?: T) {
    this.val = val;
  }

  public get value(): T {
    return this.val;
  }

  public on = (fn: (arg: T) => any) => {
    this.fs.push(fn);
  };

  public emit = (newVal: T) => {
    this.val = newVal;
    this.fs.forEach((f) => f(newVal));
  };

  public remove = (fn: (arg: T) => any) => {
    const index = this.fs.findIndex((f) => f === fn);

    if (index > -1) {
      this.fs.splice(index, 1);
    }
  };
}

const catalogService = new MessageService(emptyCatalogData);

export { catalogService };
